import { oz } from '@weft/utils';
import { CreditProductSettingsSchema } from './credit/credit-product-settings';
import { ServiceProductSettingsSchema } from './service/service-product-settings';

export const ProductSettingsSchema = oz.discriminatedUnion('productType', [
  CreditProductSettingsSchema,
  ServiceProductSettingsSchema,
]).openapi('ProductSettings');

export type ProductSettings = oz.infer<typeof ProductSettingsSchema>;